import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { ApiService } from './api.service';
import { SessionService } from './session.service';
import { AuthService } from './auth.service';
import { User, Device } from '../models';
import { observableToBeFn } from '../../../node_modules/rxjs/testing/TestScheduler';
import { ThrowStmt } from '../../../node_modules/@angular/compiler';
import { interval } from 'rxjs/observable/interval';
import { environment } from '../../environments/environment';

@Injectable()
export class AdminService {

    private teamAssignments: any;
    private teams: any;
    private teamHierarchies: any;
    private userLinks: any;
    private subTeams: any;
    private users: any;
    private activeUser: User;

    private allUserLoadedSubject = new ReplaySubject<any>(1);
    public allUserLoaded = this.allUserLoadedSubject.asObservable();

    public list_user_scope_user_team: string = 'user_team';

    constructor(
        private authService: AuthService,
        private apiService: ApiService,
        private sessionService: SessionService,
    ) { }

    getUserAndTeamInfo() {
        this.activeUser = this.authService.getActive();
        // check for team assignment feature
        if (this.activeUser) {
            let info: Array<User> = [];
            this.teamAssignments.forEach(
                ta => {
                    let u: User = {
                        ID: ta.ID,
                        client_ID: ta.client_ID,
                        user_ID: ta.user_ID,
                        username: ta.username,
                        email: ta.email,
                        first_name: ta.first_name,
                        last_name: ta.last_name,
                        title: ta.title,
                        profile: null,
                        json_custom_fields: null,
                        session_token: null,
                        expire_in: null,
                        time_zone: null,
                        home_page: null,
                        team_role: ta.team_role,
                        administrator_level: ta.administrator_level,
                        team_name: ta.team_name,
                        client_code: null,
                        logout_url: null,
                        sso_signout_url: null,
                        sso_signin_url: null,
                        team_key_ID: ta.team_key_ID,
                        team_ID: ta.team_ID
                    };
                    info.push(u);
                }
            )
        }
        return null;
    }

    getAllUsers() {
        if (this.users == undefined) {
            // console.log("must preload all users on login ");
        }
        return this.users;
    }

    getAvailableUsers(scope = null) {
        var active_user = this.authService.getActive();
        var active_user_team_ids = active_user.team_key_ID.split('_');
        var available_users = this.users;
        if (scope && scope.length > 0) {
            available_users = [];
            switch (scope) {
                case this.list_user_scope_user_team: 
                    this.users.forEach(u => {
                        if (u.team_key_ID.indexOf(active_user.team_key_ID) >= 0) available_users.push(u);
                    });
                    break;
                default: 
                    available_users = this.users;
                    break;
            }
        } else {
            if (this.isUSCell() && active_user_team_ids.length > 3) available_users = [];
            if (this.isUSCellAgent()) {
                // for uscell agent, return only the users within the user's master team (team index  = 2)
                var master_team_index = 2;
                this.users.forEach(u => {
                    var user_team_ids = u.team_key_ID.split('_');
                    if (active_user_team_ids[master_team_index] == user_team_ids[master_team_index]) available_users.push(u);
                });
            } else if (this.isUSCellCorp()) {
                available_users = [];
                // for uscell agent, return only the users within the user's area team (team index  = 4)
                var area_team_index = 5;
                this.users.forEach(u => {
                    var user_team_ids = u.team_key_ID.split('_');
                    if (active_user_team_ids[area_team_index] == user_team_ids[area_team_index]) available_users.push(u);
                });
            } else if (this.isUSCellTelesales()) {
                // for uscell telesales, return user team members
                available_users = [];
                this.users.forEach(u => {
                    if (u.team_key_ID.indexOf(active_user.team_key_ID) >= 0) available_users.push(u);
                });
            }
        }
        return available_users;
    }

    isUSCell() {
        var user = this.authService.getAuth();
        return (user && user.client_code && user.client_code.indexOf("USCELL-") >= 0);
    }
    isUSCellRetail() {
        var user = this.authService.getAuth();
        return (user && user.client_code && (user.client_code.indexOf("USCELL-RETAIL-CORP") >= 0 || user.client_code.indexOf("USCELL-RETAIL-AGENT") >= 0));
    }

    isUSCellCorp() {
        var user = this.authService.getAuth();
        return (user && user.client_code && user.client_code.indexOf("USCELL-RETAIL-CORP") >= 0);
    }

    isUSCellAgent() {
        var user = this.authService.getAuth();
        return (user && user.client_code && user.client_code.indexOf("USCELL-RETAIL-AGENT") >= 0);
    }

    isUSCellInsideSales() {
        var user = this.authService.getAuth();
        return (user && user.client_code && (user.client_code.indexOf("USCELL-RETAIL-INSIDESALES") >= 0 || user.client_code.indexOf("USCELL-RETAIL-TELESALES") >= 0));
    }

    isUSCellTelesales() {
        var user = this.authService.getAuth();
        return (user && user.client_code && user.client_code.indexOf("USCELL-RETAIL-TELE_SALES") >= 0);
    }

    getUserByUsername(username) {
        return this.users ? this.users.find(u => u.username == username) : null;
    }

    getTeamHierarchies() {
        if (this.teamHierarchies == undefined) {
            console.log("must be preloaded");
        }
        return this.teamHierarchies;
    }

    getTeamMembersByUser(user: User, bIncludeSubTeam: boolean = true): User[] {
        var members = [];
        this.users.forEach(u => {
            if (u.team_key_ID.indexOf(user.team_key_ID) >= 0) {
                members.push(u);
            }
        });
        return members;
    }

    updateTeamMember(user: User) {
        var index = this.users.findIndex(u => u.username == user.username);
        if (index >= 0) {
            this.users[index] = user;
        } else {
            this.users.push(user);
        }
    }

    getSwitchableUserLinks(currentUser, userLinks) {
        let links: any[] = [];
        userLinks.forEach(
            l => {
                var l_username = l.user.username.split('-')[0];
                var a_username = currentUser.username.split('-')[0];
                if (l_username == a_username) {
                    links.push(l);
                }
            }
        )
        return links;
    }

    getSwitchableTeamHierarchies(teamHierarcharies) {
        let hierarchies: any[] = [];
        teamHierarcharies.forEach(
            h => {
                if (h.custom_fields) {
                    h.custom_fields.forEach(
                        f => {
                            if (f.CustomFieldName == "Allow Portal Switching" && f.CustomFieldValue == "Yes") {
                                hierarchies.push(h);
                            }
                        }
                    )
                }
            }
        )
        return hierarchies;
    }

    loadUserLinks(): Observable<any> {
        let params: any = {};
        return this.apiService.get("/admin/user_links", params).map(
            (result) => {
                this.userLinks = result;
                return this.userLinks;
            }
        )
    }

    switchLinkedUser(user_link): Observable<any> {
        return this.apiService.get(`/admin/user_links/${user_link.ID}/actions/switch_user`).map(
            (result) => {
                return result;
            }
        )
    }

    loadTeamHierarchies(): Observable<any> {
        let params: any = { ro: true };
        return this.apiService.get("/admin/teams", params).map(
            (result) => {
                this.teamHierarchies = result;
                return this.teamHierarchies;
            }
        )
    }

    changeUserOnlineStatus(user, status): Observable<any> {
        return this.apiService.get(`/admin/user/${user.ID}/actions/update_user_online_status`, status).map(
            (result) => {
                return result;
            }
        )
    }

    switchHierarchy(hierarchy): Observable<any> {
        return this.apiService.get(`/admin/teams/${hierarchy.ID}/actions/switch_hierarchy`).map(
            (result) => {
                return result;
            }
        )
    }

    processUserAction(action, data, content_type?: string): Observable<any> {
        return this.apiService.post(`/models/user/action/${action}`, data, content_type).map(
            (result) => {
                return result;
            }
        )
    }

    loadAllTeams(): Observable<any> {
        return this.apiService.get("/admin/teams").map(
            (result) => {
                this.teams = result;
                return this.teams;
            }
        )
    }

    loadAllSubTeams(): Observable<any> {
        return this.apiService.get("/admin/sub_teams").map(
            (result) => {
                this.subTeams = result;
                return this.subTeams;
            }
        )
    }

    private all_users: Array<User> = [];

    loadAllUsers(exclude_up_timezone:string = "Y") {
        if (this.activeUser == null) this.activeUser = this.authService.getActive();
        let params: any = { v: `<${environment.version}-${this.activeUser.ID}>`, extz: exclude_up_timezone };
        this.apiService.get("/admin/users", params).subscribe(
            (result) => {
                this.users = result;
                this.allUserLoadedSubject.next(true);
            }
        )
    }

    loadScopeTeamUsers(team_ID: string, exclude_up_timezone:string = "Y") {
        if (this.activeUser == null) this.activeUser = this.authService.getActive();
        let params: any = { v: `<${environment.version}-${this.activeUser.ID}>`, extz: exclude_up_timezone, TID: team_ID };
        this.apiService.get("/admin/users", params).subscribe(
            (result) => {
                this.users = result;
                this.allUserLoadedSubject.next(true);
            }
        )
    }

    // recursively execute get user request until all users are loaded
    loadUserByPageIndex(page_index:number = 1, page_size:number = 200, exclude_up_timezone:string = "Y") {
        // do not get user if user list is not empty
        if (page_index == 1 && this.all_users.length > 0) return;
 
        this.getUsers(page_index, page_size, exclude_up_timezone).subscribe(users => {
            if (users && users.length > 0) {
                this.all_users = this.all_users.concat(users);
                this.loadUserByPageIndex(page_index + 1, page_size, exclude_up_timezone);
                this.sessionService.log("loading user: page: _page_index, size: _page_size".replace("_page_index", page_index.toString()).replace("_page_size", page_size.toString()));
            } else {
                this.users = this.all_users;
                this.allUserLoadedSubject.next(true);
            }
        })
    }

    getUsers(page_index: number, page_size: number, exclude_up_timezone:string = "Yes"): Observable<any> {
        let params: any = { p: page_index, ps: page_size, extz: exclude_up_timezone };
        return this.apiService.get("/admin/users", params).map(
            (result) => {
                this.users = result;
                return this.users;
            }
        )
    }

    allowUserLookup(): boolean {
        return this.authService.getActive().team_role == "L";
    }

    registerDevice(user: User, token: string): Observable<any> {
        var device: Device = new Device();
        device.pin = user.ID;
        device.push_token = token;
        device.push_token_type = "FCM";
        device.name = this.getDeviceNameFromUser(user);
        return this.apiService.put("/models/devices", device, "json").map(
            (result) => { return result; }
        )
    }

    listMyDevices(user: User): Observable<any> {
        let search_params: any = { user_ID: Number.parseInt(user.ID) };
        let params: any = { params: JSON.stringify(search_params) };
        return this.apiService.get("/models/devices", params).map(
            (result) => { return result; }
        )
    }

    deleteDevice(user: User, device_id: string): Observable<any> {
        var path = `/models/devices/${device_id}`;
        return this.apiService.delete(path).map(
            (result) => { return result; }
        )
    }

    getDeviceNameFromUser(user: User): string {
        if (user.client_code.indexOf("USCELL-RETAIL-CORP") >= 0) return "USCellular Corp Portal";
        if (user.client_code.indexOf("USCELL-RETAIL-AGENT") >= 0) return "USCellular Agent Portal";
    }

    isMessageServiceEnabled(user: User): boolean {
        if (this.sessionService.isIOSDevice()) return false;
        if (this.sessionService.getItemCustomFieldValue(user, "Disable Message Service") == "Yes") return false;
        return user.client_code.indexOf("NGMS") >= 0;
    }

    changePassword(username: string, brand: string = null, access_code: string = null): Observable<any> {
        return this.apiService.get("/session/action/change_password");
    }

    public isClientCodeDefined(code: string): boolean {
        var user = this.authService.getAuth();
        var codes = user.client_code.split('_');
        var code = codes.find(c => c == code);
        return code != null;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/admin.service.ts